<template>
  <div id="productWrapper">
    <div class="columns">
      <div class="column">
        <div class="notification" v-show="loading">Laden...</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-fifth">
        <p><router-link :to="{ name: 'products' }"><span class="icon"><i class="fas fa-chevron-left"></i></span> Terug</router-link></p>
      </div>

      <div class="column is-four-fifths-table is-half-desktop">
        <div class="card">
          <http-messages :success="success" :errors="errors"></http-messages>

          <header class="card-header">
            <p class="card-header-title">Product bewerken</p>
          </header>

          <div class="card-content">
            <form>
              <div v-if="isAdmin" class="field">
                <div class="label">
                  <label for="name" class="label">Leverancier</label>
                </div>
                <div class="control">
                  <div class="select">
                    <select name="supplier_id" v-model="product.supplier_id">
                      <option v-for="supplier in suppliers" :value="supplier.id">{{ supplier.name }}</option>
                    </select>
                  </div>
                </div>
                <p v-for="message in errors.supplier_id" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <div class="label">
                  <label for="name" class="label">Naam</label>
                </div>
                <div class="control">
                  <input class="input" type="text" name="name" v-model="product.name">
                </div>
                <p v-for="message in errors.name" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <div class="label">
                  <label for="description" class="label">Beschrijving <span v-if="product.description" class="is-pulled-right">({{ product.description.length }}/3000)</span></label>
                </div>
                <div class="control">
                  <vue-editor v-model="product.description" :editorToolbar="customToolbar"></vue-editor>
                </div>
                <p v-for="message in errors.description" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <div class="label">
                  <label for="series" class="label">Model</label>
                </div>
                <div class="control">
                  <input class="input" type="text" name="series" v-model="product.series" placeholder="jaar, nummer o.i.d.">
                </div>
                <div class="field">
                  <div class="label">
                    <label for="series" class="label">Serie</label>
                  </div>
                  <div class="control">
                    <input class="input" type="text" name="model" v-model="product.model" placeholder="model aanduiding">
                  </div>
                </div>
              </div>

              <hr/>

              <p class="has-text-weight-bold">Afbeeldingen</p>

              <div class="notification is-danger" :class="{ 'is-hidden': !tooLarge && !invalidExtension }">
                <p v-show="tooLarge">Het bestand is te groot, de maximale toegestane bestandsgrootte is 2MB.</p>
                <p v-show="invalidExtension">Dit bestandstype is niet toegestaan. Alleen .jpg en .png zijn toegestane bestandstypen</p>
              </div>

              <div v-if="product.images" class="is-clipped">
                <article v-for="(image, index) in product.images" class="media">
                  <div class="media-left">
                    <figure class="image is-128x128" :style="'background-image: url(' + image.file + ')'"></figure>
                  </div>

                  <div class="media-content">
                    <div class="field is-horizontal">
                      <div class="field-label is-small">
                        <label class="label">Naam</label>
                      </div>

                      <div class="field-body">
                        <div class="field">
                          <p class="control">
                            <input class="input" type="text" v-model="image.name">
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="field is-horizontal">
                      <div class="field-label is-small">
                        <label class="label">Bijschrift</label>
                      </div>

                      <div class="field-body">
                        <div class="field">
                          <p class="control">
                            <input class="input" type="text" v-model="image.caption">
                          </p>
                        </div>
                      </div>
                    </div>

                    <nav class="level is-mobile is-pulled-right">
                      <div class="level-left">
                        <a class="level-item" aria-label="delete" @click="removeImage(index)">
                          Afbeelding verwijderen
                        </a>
                      </div>
                    </nav>
                  </div>
                </article>
              </div>

              <hr/>

              <v-uploader @done="uploadDone" :preview="false" button-text="Nieuwe afbeelding uploaden" file-size-limit="2MB"></v-uploader>
              <ul class="upload-rules">
                <li>Afbeeldingen mogen maximaal 2MB groot zijn</li>
                <li>Toegestane bestanden zijn .jpg en .png</li>
              </ul>

            </form>

          </div>

          <footer class="card-footer">
            <a
            class="button is-text card-footer-item"
            @click="save"
            :class="{ 'is-loading': loading }">
            Opslaan
            </a>
          </footer>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-four-fifths-tablet is-half-desktop is-offset-one-fifth">
        <button type="button" class="button is-danger is-fullwidth" @click="delProduct">Product verwijderen</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '../../main'
  import { VueEditor } from 'vue2-editor'
  import HttpMessages from '@/components/http/HttpMessages'

  export default {
    components: {
      HttpMessages,
      VueEditor
    },
    data() {
      return {
        loading: false,
        errors: {},
        success: false,
        invalidExtension: false,
        tooLarge: false,
        product: {
          images: []
        },
        suppliers: {},
        customToolbar: [
          ['bold', 'italic', 'underline', 'link'],
          [{ list: 'ordered'}, {list: 'bullet'}]
        ]
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      isSupplier () {
        return this.$store.getters.isSupplier
      },
      params () {
        return this.$store.getters.params
      },
      accountData () {
        return this.$store.getters.accountData
      }
    },
    created () {
      let self = this

      if (this.$route.params.id) this.fetchData(this.$route.params.id)

      if (this.isAdmin)
        this.fetchSuppliers()

      bus.$on('uploadError', (payload) => {
        if (payload.includes('too large')) {
          self.tooLarge = true
        }

        if (payload.includes('invalid extension')) {
          self.invalidExtension = true
        }
      })
    },
    methods: {
      fetchData (id) {
        this.loading = true
        axios
          .get('/products/' + id, this.params)
          .then(response => {
            this.loading = false
            this.product = response.data
            if (!this.product.images)
              this.product.images = []
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          });
      },
      fetchSuppliers () {
        this.loading = true
        axios
          .get('/suppliers', this.params)
          .then(response => {
            this.loading = false
            this.suppliers = response.data
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          });
      },
      save () {
        this.loading = true
        this.errors = {}
        this.success = false

        if (this.product.id) {
          axios
            .put('/products/' + this.product.id, this.product)
            .then(response => {
              this.loading = false
              this.success = true
            })
            .catch((error) => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        } else {
          if (this.isSupplier) this.product.supplier_id = this.accountData.supplier.id

          axios
           .post('/products', this.product)
           .then(response => {
            this.loading = false
            this.success = true
            this.product = response.data
           })
           .catch((error) => {
            this.loading = false
            this.errors = error.response.data.errors
           })
        }
      },
      uploadDone (files) {
        this.clearErrors()
        if (files[0].success) this.product.images.push({file: files[0].url})
      },
      removeImage (index) {
        this.product.images.splice(index, 1)
      },
      delProduct () {
        axios
          .delete('/products/' + this.product.id)
          .then(response => {
            this.$router.push({name: 'products'})
          })
          .catch((error) => {
            console.log(error)
          })
      },
      clearErrors () {
        this.tooLarge = this.invalidExtension = false
      }
    }
  }
</script>

<style scoped>
  .button.is-text {
    text-decoration: none;
  }

  .media-content .level {
    margin-top: 2rem;
  }

  figure {
    margin: 15px 15px 15px 0;
    background-color: #ddd;
    background-size: cover;
  }

  .is-overlay {
    left: 5px;
    top: 5px;
  }

  .upload-rules {
    font-size: 10px;
    font-weight: light;
  }
</style>



// WEBPACK FOOTER //
// src/components/products/ProductEdit.vue